import script from "./TableJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./TableJobs.vue?vue&type=script&setup=true&lang=js"

import "./TableJobs.vue?vue&type=style&index=0&id=e42d6a44&lang=css"

const __exports__ = script;

export default __exports__